<template>
  <div class="c-column-style">
    <el-collapse>
      <el-collapse-item title="绘图区域">
        <style-sub-item title="配色设置">
          <el-form-item>
            <div class="c-column-style-themes">
              <div class="c-column-style-theme" v-for="(item, idx) in dataList" :key="idx">
                <el-color-picker @change="(color)=>handleChange(item, color)"
                  v-model="item[customKey + 'seriesColor']"></el-color-picker>
                <span>{{ item[customKey + 'text'] }}</span>
              </div>
            </div>
          </el-form-item>
        </style-sub-item>
        <el-form-item>
          <div class="chart-form-item-warp" style="margin-top: 0">
            <span class="jz-chart-title-label">透明度</span>
            <el-slider style="flex:1"
              v-model="selectItem.styleConfig.commongConfig.columnBackgroundOpacity"></el-slider>
          </div>
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">开启渐变效果</span>
            <el-switch v-model="selectItem.styleConfig.commongConfig.gradientEffect">
            </el-switch>
          </div>
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">
              柱图宽度
              <el-tooltip content="当您配置的柱体宽度超出最大宽度范围时，该配置将不再生效。" placement="top" effect="dark">
                <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: help;"></i>
              </el-tooltip>
            </span>
            <el-slider style="flex:1" :format-tooltip="formatTooltip"
              v-model="selectItem.styleConfig.commongConfig.columnWidthRatio"></el-slider>
          </div>
        </el-form-item>
      </el-collapse-item>
      <legend-style :config="selectItem.styleConfig.commongConfig.legendConfig"></legend-style>
      <el-collapse-item title="数据标签">
        <el-form-item>
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">是否开启</span>
            <el-switch v-model="selectItem.styleConfig.commongConfig.labelConfig.show">
            </el-switch>
          </div>
          <div class="chart-form-item-warp">
            <el-checkbox v-model="selectItem.styleConfig.commongConfig.labelConfig.showAll">全量显示</el-checkbox>
          </div>
          <div class="chart-form-item-warp">
            <span class="jz-chart-title-label">位置</span>
            <el-select v-model="selectItem.styleConfig.commongConfig.labelConfig.position" placeholder="请选择"
              popper-class="c-select-style-popper">
              <el-option label="自动" value=""></el-option>
              <el-option label="顶部" value="top"></el-option>
              <el-option label="底部" value="bottom"></el-option>
              <el-option label="中间" value="middle"></el-option>
              <el-option label="左侧" value="left"></el-option>
              <el-option label="右侧" value="right"></el-option>
            </el-select>
          </div>
          <text-style :config="selectItem.styleConfig.commongConfig.labelConfig.textConfig"></text-style>
        </el-form-item>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import styleSubItem from '../base/styleSubItem.vue'
import { transferObjectToArray, getFieldValueByCustomKey, updateFieldMapColor } from '../../utils/index'
import { customKey } from '../../utils/enum.data'
import textStyle from '../base/textStyle.vue'
import legendStyle from '../base/legendStyle.vue'
export default {    
  name: 'cColumnStyle',
  components: {
    styleSubItem,     
    textStyle,
    legendStyle
  },
  props: {
    selectItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      getFieldValueByCustomKey,
      customKey
    }
  },
  computed: {
    dataList() {
      return transferObjectToArray(this.selectItem)
    }
  },
  methods: {
    handleChange(item, color) {
      // 使用工具函数更新颜色，forceReactive 设为 true 以强制触发响应式更新
      updateFieldMapColor(this, this.selectItem, item, customKey, color, true)
      console.log(item, color, 'item, color', this.selectItem.styleConfig.helperData)
    },
    formatTooltip(value) {
      return `${value}%`
    }
  }
}
</script>
<style scoped lang="less">
.c-column-style {
  .c-column-style-theme{
    &:not(:first-child){
      margin-top: 2px;
    }
    display: flex;
    align-items: center;
    margin-bottom: 2px;
    background: #fff;
    padding: 6px 12px;
    span{
      flex: 1;
      text-align: left;
      margin-left: 8px;
    }
    .el-color-picker{
      width: 26px;
    }
  }
  
  // 暗黑主题样式覆盖
  /deep/ .el-select-dropdown {
    background-color: #2c2f36 !important;
    border: 1px solid #404040 !important;
  }
  
  /deep/ .el-select-dropdown__item {
    background-color: #2c2f36 !important;
    color: #ffffff !important;
    
    &:hover {
      background-color: #404040 !important;
    }
    
    &.selected {
      background-color: #1890ff !important;
      color: #ffffff !important;
    }
  }
  
  /deep/ .el-select-dropdown__empty {
    color: #909399 !important;
  }
}

// 全局样式，用于覆盖 popper 渲染到 body 中的下拉框
</style>